<template>
  <Sonner
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)'
    }"
    v-bind="props"
  />
</template>

<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from "vue-sonner"

const props = defineProps<ToasterProps>()
</script>
